import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container } from "semantic-ui-react";
import { withAuthorization } from "../../components/Session/withAuthorization";
const LandingComponent = ({
  authUser,
  orgId,
  history,
  match,
  location,
}: any) => <Container className="main-container">Landing Page</Container>;

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
});

const authCondition = (authUser: any) => !!authUser;

const Landing = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(LandingComponent));
export default Landing;



// WEBPACK FOOTER //
// ./src/containers/Landing/index.tsx